import axios from 'axios'

let api = {
  get: (path, token = null) => {
    return new Promise(function (resolve, reject) {
      let config = api.config(token)
      axios.get(
        `${process.env.API}${path}`,
        config
      ).then((resp) => {
        resolve(resp.data)
      }).catch(() => {
        reject()
      })
    })
  },
  post: (path, body, token = null) => {
    return new Promise(function (resolve, reject) {
      let config = api.config(token)
      axios.post(
        `${process.env.API}${path}`,
        body,
        config
      ).then((resp) => {
        resolve(resp.data)
      }).catch(e => {
        console.log(e)
        reject(e)
      })
    })
  },
  config (token = null) {
    let config = { headers: {}}
    if (token) {
      config.headers['Content-Type'] = 'application/json'
      config.headers['Access-Control-Allow-Headers'] = 'x-access-token'
      config.headers['x-access-token'] = token
    }
    return config
  }
}

export default api



//////////////////
// WEBPACK FOOTER
// ./helpers/api.js
// module id = wQAA
// module chunks = 15